import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const PriceLabel = (props) => {
    const { t } = useTranslation();
    const currency = useSelector((store) => store.currency);

    return (
        <div className={"price-label" + (props.from === "strategy" ? " mr-0 mr-sm-3 order-2" : "")}>
            <h3 
                className={"text-color-changeable" + (props?.item?.price > 0 || props?.from === "strategy" ? "" : " d-none")}
                data-test-id={"mrkt-price" + (props?.from === "strategy" && props?.item?.price > 0 ? "" : props?.dti && props?.item?.price > 0 ? "-"+props.dti : "-free")}
            >
                {props.item.price > 0 ? props.item.price + "" + currency?.symbol : t("strategy.free")}
            </h3>
            {
                props?.item?.role === "admin" ?
                <div data-test-id={"mrkt-byoppo-" + props?.dti} className="text-color-changeable text-bold text-small">{t("by Opportrade")}</div>
                : null
            }
        </div>
    );
};